
import LeftSideVue from '@/components/Sidebar/LeftSide.vue'
import RightSideVue from '@/components/Sidebar/RightSide.vue'

export default{
  name: 'HomeView',
  props: ['children'],
  components: {
    LeftSideVue,
    RightSideVue
  }
}
